import api from "./api";

export interface UsersAcceptInvitationProps {
  inviteToken: string;
}

interface UsersAcceptInvitationParams {
  invite_token: string;
}

export const usersAcceptInvitation = async (
  props: UsersAcceptInvitationProps
) => {
  const params: UsersAcceptInvitationParams = {
    invite_token: props.inviteToken,
  };
  const res = await api.post<unknown>("/users/accept-invitation", params);
  return res;
};
